<template>
  <div>
    <v-dialog v-model="show" @click:outside="close" width="500">
      <!--<v-container fluid style="padding: 0px!important;overflow: hidden;">-->
      <div class="modal">
        <v-row>
          <v-col class="table-cell modal-content">
            <p class="mb-5" style="text-align: center">
              <b style="font-size: 22px!important">Select an account</b>
            </p>
            <template v-if="show_search">
              <v-text-field
                  v-model="search"
                  placeholder="Search..."
                  hide-details
                  class="input_search"
                  color="#198beb"
              >
                <img
                    :src="require('@/assets/img/search.svg')"
                    slot="prepend"
                    alt="help"
                    class="info-tooltip"
                />
              </v-text-field>
            </template>


            <v-list class="mb-5">
              <v-list-item v-for="(item, index) in filteredItems" :key="index" @click="selectItem(index)">
                <v-list-item-content>
                  <v-list-item-title style="color:darkslategray">{{ item.company_name }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <span class="kb-check" :class="{ checked: item.selected }">
                    <svg v-if="item.selected" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                  </span>
                </v-list-item-action>
              </v-list-item>
            </v-list>
            <v-btn
                block
                rounded
                depressed
                class="btn-azul text-center mb-5"
                style="min-width: 300px !important; margin: 0 auto;"
                @click="confirmItem"
            >ACCEPT
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </v-dialog>
  </div>
</template>
<script>

  export default {
    props: ['show', 'hide', 'user', 'tenants', 'onInactive'],
    components: {
    },
    data() {
      return {
        localItems: this.tenants,
        search: '',
        show_search: this.user.user_role === 'super_user'
      }
    },
    created() {
      this.initLocalItems();
    },
    watch: {
      tenants() {
        this.initLocalItems();
      },
      show(val) {
        if (val) {
          for(const item of this.localItems) {
            item.selected = false;
            if (item.tenant_id === this.user.tenant_current_logged) {
              item.selected = true;
            }
          }
        }
      }
    },
    computed: {
      filteredItems() {
        return this.localItems.filter(item => {
          if (!this.search) return this.localItems;
          return (item.company_name.toLowerCase().includes(this.search.toLowerCase()));
        })
      }
    },
    methods: {
      initLocalItems() {
        this.localItems = [];
        for (const item of this.tenants) {
          this.localItems.push({
            ...item,
            selected: item.tenant_id === this.user.tenant_current_logged
          })
        }
      },
      close: function () {
        this.hide();
      },
      selectItem(index) {
        for (const item of this.filteredItems) {
          item.selected = false;
        }
        this.filteredItems[index].selected = true;
      },
      confirmItem() {
        const selectedItem = this.filteredItems.find(x => x.selected);
        if (selectedItem || this.filteredItems.length === 0) {
          this.onSelectItem(selectedItem);
        }
      },
      async onSelectItem(item) {
        const self = this;
        let dataToSend = {
          "user_id": this.user.phone_number,
          "tenant_id": item.tenant_id,
          "user_role": item.role,
        };

        let inactiveAccontExist = Object.values(this.user.tenants_list)
          .find(
            x => x.tenant_id === item.tenant_id &&
              x.role !== item.role &&
              x.status === 'inactive'
          );

        if (inactiveAccontExist) {
          self.onInactive({inactive: inactiveAccontExist, active: item});
        } else {
          self.hide();
          self.$store.dispatch('Users_list/clear_data');
          self.$store.commit('Users_list/setUxDocs', []);
          self.$store.commit('Users_list/setUxTenantDocs', []);
          self.$store.dispatch('Authenticate/activate_ut', dataToSend);
        }
      },
      onSelectTenant(item) {
        const self = this;
        let dataToSend = {
          "user_id": this.user.phone_number,
          "tenant_id": item.tenant_id,
          "user_role": item.role,
        };
        self.hide();
        self.$store.dispatch('Users_list/clear_data');
        self.$store.commit('Users_list/setUxDocs', []);
        self.$store.commit('Users_list/setUxTenantDocs', []);
        self.$store.dispatch('Authenticate/activate_ut', dataToSend);
      }
    },
  };
</script>
<style scoped>
.kb-check {
  width: 22px;
  height: 22px;
  min-width: 22px;
  border-radius: 6px;
  border: 2px solid #aeaeb2;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.15s;
  background: transparent;
}
.kb-check.checked {
  background: #3478f6;
  border-color: #3478f6;
}
</style>